module.exports = __webpack_public_path__ + "media/images/gallery/constellations/capricornus/cap_names-40faf562d7c45212aa8404597db85e86.gif";